import DeleteIcon from '@mui/icons-material/Delete';



function DeleteIcons({onClick})
{
 
        return   <DeleteIcon onClick={onClick} style={{cursor:'pointer'}}/>
    
}

export default DeleteIcons